<template>    

    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'userList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>
            <div class="table__form">
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Nome</strong>
                    </div>
                    <input type="text" v-model="user.name">
                </div>
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Cognome</strong>
                    </div>
                    <input type="text" v-model="user.surname">
                </div>
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Ruolo</strong>
                    </div>
                    <select v-model="user.role_id">
                        <option v-for="role in userRoles" v-bind:value="role.id" :key="role.id">{{ role.role }}</option>
                    </select>
                </div>
                <div class="form_inline" v-if="user.role_id > 3">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Progetti</strong>
                    </div>
                    <select v-model="userProjects" multiple>
                        <option v-for="project in projects" v-bind:value="project.id" :key="project.id">{{ project.project }}</option>
                    </select>
                </div>
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Email</strong>
                    </div>
                    <input type="text" v-model="user.email">
                </div>
<!--                <div class="form_inline">-->
<!--                    <div class="w-25 mr-2">-->
<!--                                <strong class="label-form">Password</strong>-->
<!--                            </div>-->
<!--                    <input type="password" v-model="user.password">-->
<!--                </div>-->
                <div class="bcm_action" style="display: flex; justify-content: space-between;">

                    <div>
                        <div>
                            <div><strong>Created</strong>: {{ user.requestLogCreate }}</div>
                        </div>
                        <div>
                            <div><strong>Updated</strong>: {{ user.requestLogUpade }}</div>
                        </div>
                    </div>
                    <input type="button" :value="btn" v-on:click="saveUser()">
                </div>
            </div>

        </div>
    </section>

</template>
<script>

    import { mapGetters } from 'vuex'

    export default {
        data: () => ({
            title: 'Utente',
        }),

        computed: {

            ...mapGetters(
                {
                    user: 'usersModule/user',
                    userRoles: 'usersModule/userRoles',
                    userProjects: 'usersModule/userProjects',
                    projects: 'usersModule/projects',
                    hasPermission: 'hasPermission'
                }
            ),
            //...mapGetters('userRoles'),

            setTitle : function() {

                var ret = {};

                if(this.$route.params.action == 'create'){

                    ret.title = "Create"

                } else {

                    ret.title = "Edit"

                }
                return ret

            },

            btn: function(){
                if(this.$route.params.action == 'create'){
                    return "Salva"
                } else {
                    return "Modifica"
                }
            },

            userProjects: {
                set(val){
                    this.$store.state.usersModule.userProjects = val
                },
                get(){
                    return this.$store.state.usersModule.userProjects
                }
            }
        },

        methods: {
            loadUser () {
                this.$store.dispatch('usersModule/loadUser', {urlToConnect: 'users/'+this.$route.params.id+'/edit', id: this.$route.params.id})
            },

            createUser () {
                this.$store.dispatch('usersModule/createUser', {urlToConnect: 'users/create'})
                this.$store.state.usersModule.user.role_id = 1;
                this.$store.state.usersModule.user.requestLogCreate = '/';
                this.$store.state.usersModule.user.requestLogUpade = '/';
            },

            saveUser(){
                
                var parameters = {
                    urlToConnect: 'users',
                    methodToConnect: 'post',
                    name: this.$store.state.usersModule.user.name,
                    surname: this.$store.state.usersModule.user.surname,
                    role_id: this.$store.state.usersModule.user.role_id,
                    userProjects: this.$store.state.usersModule.userProjects,
                    // password: this.$store.state.usersModule.user.password,
                    email: this.$store.state.usersModule.user.email,
                }
                
                if(this.$route.params.action == 'edit'){
                    parameters.urlToConnect = 'users/' + this.$route.params.id;
                    parameters._method = "patch";
                }

                this.$store.dispatch('usersModule/saveUser', parameters).then((data) => {
                    if (this.$route.params.action === 'create') {
                        if(this.hasPermission('Users', 'edit')){
                            this.$router.replace("/users/" +data.id+ "/edit")
                        } else {
                            this.$router.replace("/users")
                        }
                    }
                })

            }
        },
        watch: {
            '$route' () {
                if(this.$route.params.action == 'edit') {
                    this.loadUser()
                } else if(this.$route.params.action == 'create') {
                    this.createUser();
                }
            }
        },
        created () {
            if(this.$route.params.action == 'edit') {
                this.loadUser()
            } else if(this.$route.params.action == 'create') {
                this.createUser()
            }
        }




    }
</script>